const waitForFormEmbed = setInterval(() => {
  const formEmbed = document.querySelector(
    ".ebook-download__section .ebook-download__form form-embed"
  )

  if (formEmbed && formEmbed.shadowRoot) {
    const formWrap = formEmbed.shadowRoot.querySelector(
      'section[data-sizing="form-wrapper"]'
    )
    const fieldset = formEmbed.shadowRoot.querySelector(
      'form[class*="_formFieldset"]'
    )
    const shadowRoot = formEmbed.shadowRoot

    if (formWrap) {
      formWrap.style.maxWidth = "100%"
    }

    if (fieldset) {
      fieldset.style.flexWrap = "wrap"
      const customFieldset = fieldset.querySelector(
        'fieldset[name="custom\\#check"]'
      )
      customFieldset.style.height = "0"
      customFieldset.style.overflow = "hidden"
      customFieldset.querySelector("legend").style.display = "none"
      fieldset.querySelector("button").style.height = "0"
      fieldset.querySelector("button").style.padding = "0"
      fieldset.querySelector("button").style.visibility = "hidden"
      const style = document.createElement("style")
      style.textContent = `
              form[class*="_formFieldset"] {
                flex-direction: row !important;
                column-gap: 20px !important;
                row-gap: 32px !important;
                padding-bottom: 1px !important;
                padding-inline: 1px !important;
              }
    
              section[data-sizing="form-wrapper"] {
                max-width: 100% !important;
                min-height: 0 !important;
              }
    
              section[data-sizing="form-wrapper"] input::placeholder,
              section[data-sizing="form-wrapper"] textarea::placeholder {
                color: rgba(var(--color-primary-white));
                opacity: 1;
                font-weight: 400;
                font-size: 0.875rem;
                line-height: 200%;
                letter-spacing: 0.4px;
              }
    
              section[data-sizing="form-wrapper"] form div:has(input) {
                width: calc(50% - 10px);
              }
              
              section[data-sizing="form-wrapper"] form div:has(textarea) {
                width: 100%;
              }
              
              section[data-sizing="form-wrapper"] form div:has(input[id="custom#how_did_you_hear_about_us"]) {
                width: 100%;
              }
    
              section[data-sizing="form-wrapper"] input {
                box-sizing: border-box;
                max-width: 100%;
                width: 100%;
                position: relative;
                min-height: 3.25rem;
                border-width: 1px;
                border-radius: 2.5rem;
                padding-block: 0.75rem;
                border-style: solid;
                border-color: rgba(var(--color-primary-white));
                padding-inline: 1.5rem;
                font-size: 0.875rem;
                line-height: 1.5rem;
                background-color: transparent;
                color: rgba(var(--color-primary-white));
                margin-top: 1px;
              }
    
              section[data-sizing="form-wrapper"] div[class*="_withError"] input,
              section[data-sizing="form-wrapper"] div[class*="_withError"] textarea  {
                border-width: 0;
              }
    
              section[data-sizing="form-wrapper"] output {
                display: none;
              }
    
              section[data-sizing="form-wrapper"] textarea {
                box-sizing: border-box;
                max-width: 100%;
                width: 100%;
                position: relative;
                min-height: 10rem;
                border-width: 1px;
                border-radius: 1rem;
                border-style: solid;
                border-color: rgba(var(--color-primary-white));
                padding-inline: 1.5rem;
                padding-top: 1.25rem;
                padding-bottom: 1rem;
                font-size: 0.875rem;
                line-height: 1.5rem;
                background-color: transparent;
                color: rgba(var(--color-primary-white));
              }
    
              section[data-sizing="form-wrapper"] input:focus,
              section[data-sizing="form-wrapper"] input:focus-visible,
              section[data-sizing="form-wrapper"] textarea:focus,
              section[data-sizing="form-wrapper"] textarea:focus-visible {
                outline-width: 0px;
                border: 1px solid;
                border-color: rgb(var(--color-accents-yellow));
                box-shadow: unset;
              }
    
              section[data-sizing="form-wrapper"] input + label,
              section[data-sizing="form-wrapper"] textarea + label {
                display: none;
              }
    
              section[data-sizing="form-wrapper"] section[data-testid="banner-success"] h2 {
                font-family: var(--font-body);
                font-weight: 700;
                font-size: 0.875rem;
                line-height: 1.25rem;
                letter-spacing: 1.4px;
                text-transform: uppercase;
                color: rgb(var(--color-primary-white));
                justify-content: left;
              }
    
              section[data-sizing="form-wrapper"] section[data-testid="banner-success"] p {
                 font-family: var(--font-heading);
                  font-size: 2.5rem;
                  line-height: 3.5rem;
                  letter-spacing: 0.6px;
                text-transform: none;
                color: rgb(var(--color-primary-white));
                text-align: left;
                margin-bottom: 1rem;
              }
    
              @media (max-width: 990px) {
                form[class*="_formFieldset"] {
                  flex-direction: column !important;
                  gap: 24px !important;
                  margin-bottom: -48px;
                }
                
                section[data-sizing="form-wrapper"] form div:has(input) {
                  width: 100%;
                }
    
                 section[data-sizing="form-wrapper"] input {
                  max-width: 100%;
                  width: 100%;
                }
    
                div[data-testid="app-router"] {
                  display: block;
                }

                section[data-sizing="form-wrapper"] section[data-testid="banner-success"] h2 {
                 font-size: 0.6875rem;
                line-height: 1rem;
                letter-spacing: 1px;
                }

                section[data-sizing="form-wrapper"] section[data-testid="banner-success"] p {
                  font-size: 1.625rem;
                  line-height: 2.25rem;
                }
              }
            `
      shadowRoot.appendChild(style)
      fieldset.querySelectorAll("input").forEach((input) => {
        if (input.nextElementSibling && input.nextElementSibling.innerText) {
          input.placeholder = input.nextElementSibling.innerText
        }
      })

      document
        .getElementById("custom-check-agree")
        .addEventListener("click", (e) => {
          fieldset.querySelector('input[value="Downloaded e-book"]').click()
        })
      document
        .querySelector(".ebook-download__button")
        .addEventListener("click", (e) => {
          let shadowForm = formEmbed.shadowRoot.querySelector(
            'form[class*="_formFieldset"]'
          )

          if (shadowForm) {
            const shadowButton = shadowForm.querySelector(
              'button[type="submit"]'
            )
            shadowButton.click()
          }

          setTimeout(() => {
            if (formEmbed.shadowRoot.querySelector('section[data-testid="banner-success"]')) {
                const link = document.createElement("a")
                link.href = e.target.getAttribute("data-guide-link")
                link.target = "_blank"
                link.download = "ebook.pdf"
                link.click()
            } else {
              console.log("Success banner not found")
            }
          }, 2000)
        })
      clearInterval(waitForFormEmbed)
    }
  }
}, 200)
